import React, { Component } from 'react';
import PageHead from '../components/pageHead';
import Layout from '../components/Layout';
import '../sass/_home.scss';
import '../sass/_contact-us.scss';
import TalkData from '../components/talk-data';
import { Container, Row, Col } from 'react-bootstrap';
import Cbutton from '../components/button';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import UxUi from '../components/ux-ui';
import Devalopment from '../components/devalopment';
import Analytics from '../components/analytics';
import Marketing from '../components/marketing';
import ScrollAnimation from 'react-wow';
import Header from '../components/header';
import PeopleCurosel from '../components/people-cursole';
import Modal from 'react-bootstrap/Modal';
import SERVICE from '../rest-api/api-call.js';

const meta = {
    "metatitle": 'Managed Software Services and Product Development - AXLR Data',
    "metaDescription": 'Corporate IT services to deliver best-in-class UI/UX design for your products, develop Web/Mobile Apps, Automation Systems and Digital Marketing to enable you reach your business goals',
    "metaKeywords": 'Data analytics company, Data analytics company in India, Big data analytics,'
}
export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            phone_number: '',
            email: '',
            message: '',
            formValid: false,
            inValidEmail: false,
            show: false,
            validPhone: false
        }
    }

    handleClose = () => {
        this.setState({
            show: false
        })
    }

    handleShow = () => {
        this.setState({
            show: true
        })
    }

    handleUserInput(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
    }

    handleClick(event) {
        const name = this.state.name
        const phone = this.state.phone_number
        const email = this.state.email
        const message = this.state.message
        const creds = { name: name, phone_number: phone, email: email, message: message }
        this.setState({ formValid: true })
        if (creds.phone_number.length > 10 && creds.phone_number.length <= 12) {
            this.setState({ validPhone: false })
        } else {
            this.setState({ validPhone: true })
        }
        if (creds.name == '' || creds.phone_number == '' || creds.email == '' || !this.state.validPhone
            || !(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i).test(creds.email)) {
            if (!(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i).test(creds.email)) {
                this.setState({
                    inValidEmail: true
                })
            } else {
                this.setState({
                    inValidEmail: false
                })
            }
            return false
        }
        SERVICE._ContactUs(creds).then(res => {
            this.handleShow()
            this.setState({
                name: '',
                phone_number: '',
                email: '',
                message: '',
                formValid: false,
                inValidEmail: false,
                validPhone: false
            })
        }).catch(e => { });
    }

    render() {
        let { name, phone_number, email, message, formValid, inValidEmail, show, validPhone } = this.state
        return (
            <div>
                <Header />
                <PageHead title="AXLR DATA PVT LTD | Software Solutions" meta={meta}></PageHead>
                <Layout>
                    <section className="top-sec mb-5">
                        <Container>
                            <Row>
                                <Col md>
                                    {/* <ScrollAnimation animation='bounceInLeft'> */}
                                    <div className="mt-4 mb-4 pt-2 pb-4">
                                        <div className="main-heading-home pt-sm-5">Decode your</div>
                                        <div className="main-heading-home">business'digital</div>
                                        <div className="main-heading-home">transformation.</div>
                                        <div className="talk-content pt-sm-4">Accomplish complex business challenges through nimble tech and elegant designs</div>
                                        <div className="mt-sm-4 pt-sm-3 pb-sm-5">
                                            <Cbutton name="GET STARTED" extra={true} route="get-estimate" />
                                        </div>
                                    </div>
                                    {/* </ScrollAnimation> */}
                                </Col>
                                {/* <Col>
                                    <ScrollAnimation animation='bounceInRight'>
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/home-top.png`} alt="home-top" className="w-100 pt-sm-2" />
                                    </ScrollAnimation>
                                </Col> */}
                                <Col className="text-center pt-1">
                                    <video className="width-vedio" autoPlay loop muted playsInline>
                                        <source src={`${publicRuntimeConfig.staticFolder}/images/svg-vedio.mp4`} type="video/mp4" />
                                    </video>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section>
                        <Modal show={show} onHide={this.handleClose.bind(this)}>
                            <Modal.Header closeButton></Modal.Header>
                            <Modal.Body className="text-center">
                                <div className="text-center pb-2">
                                    <svg class="checkmark check-scss" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26"
                                            cy="26" r="25" fill="none" /><path class="checkmark__check"
                                                fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
                                </div>
                                <div className="spectial-content pt-5 pb-3">
                                    We received your information!. <br /> Our expert team will get back to you soon.
                                </div>
                            </Modal.Body>
                        </Modal>
                    </section>
                    {/* <section>
                        <Container>
                            <SlickSlider />
                        </Container>
                    </section> */}
                    <section className="tanla-sed">
                        <section className="tanla-sec pb-5">
                        <ScrollAnimation animation='wobble' initiallyVisible={true} className="desktop" >
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/extra-style.svg`} alt="extra-style" className="talk-sps-img desktop" />
                        </ScrollAnimation>
                            <Container className="text-center">
                                <div className="text-center main-heading-home edge desktop">The Axlr Edge</div>
                                <br className="mobile" />
                                <div className="text-center main-heading-home edge pt-0 mt-5 mobile-xxsd mobile">The</div>
                                <div className="text-center main-heading-home edge pt-0 axlr-underline mobile-xxsd ml-3 mr-3 mobile">axlr</div>
                                <div className="text-center main-heading-home edge pt-2 mobile mobile-xxsd">edge</div>
                                <div className="pb-5">
                                    <Row>
                                        <Col md>
                                            <div className="text-center pt-5 mt-5">
                                                <img src={`${publicRuntimeConfig.staticFolder}/services-img/people.png`} alt="people" className="m-auto pt-sm-4" />
                                                <div className="footer-nav ppl ppl-09pp pt-5 AxlredgeCords">People</div>
                                                <div className="footer-nav-link ppl pt-3">
                                                    Lead by a team of world-class engineers, developers and professionals with expertise in accomplishing business challenges
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md>
                                            <div className="text-center pt-5 mt-5">
                                                <img src={`${publicRuntimeConfig.staticFolder}/services-img/techknowledge.png`} alt="techknowledge" className="m-auto pt-sm-4" />
                                                <div className="footer-nav ppl ppl-09pp pt-5 AxlredgeCords">Technology</div>
                                                <div className="footer-nav-link ppl pt-3">
                                                    Led by industry-standard best practices in building technology solutions
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md>
                                            <div className="text-center pt-5 mt-5">
                                                <img src={`${publicRuntimeConfig.staticFolder}/services-img/partnership.png`} alt="partnership" className="m-auto pt-sm-4" />
                                                <div className="footer-nav ppl ppl-09pp pt-5 AxlredgeCords">Partnerships</div>
                                                <div className="footer-nav-link ppl pt-3">
                                                    Proven track record of creating goal-oriented partnerships aimed at helping organizations realize business goals
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Container>
                        </section>
                    </section>
                    <section className="people-saying-sec pt-sm-5">
                        <Container className="pt-5 mb-sm-4 pb-sm-4">
                            <div className="text-center main-heading-home mb-4 pt-sm-4">What People are saying</div>
                            <div className="m-auto">
                                <PeopleCurosel />
                                <Row>
                                    <Col className="text-center">
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/Bottom_Line.svg`} alt="green-flower-pot" className="w-100 m-auto" />
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </section>
                    <div className="mobile-pad">
                        <UxUi />
                        <Devalopment />
                        <Analytics />
                        <Marketing />
                    </div>
                    <section className="mt-5 pt-5 mb-sm-5 pb-sm-4">
                        <Container>
                            <Row>
                                <Col className="pl-sm-0 pr-sm-0" md={5}>
                                    <ScrollAnimation animation='bounceInLeft'>
                                        <div className="head-office-box pt-sm-5 pl-sm-4">
                                            <Row>
                                                <Col md>
                                                    <div className="case-study-heading pt-sm-1 pl-sm-4 head-office-color pt-sm-3 form-090f">
                                                        Let's chat
                                                    </div>
                                                    <div className="case-study-heading pt-sm-1 pl-sm-4 head-office-color pt-sm-3 form-090ppf text-white">
                                                        Ask us how we can
                                                    </div>
                                                    <div className="pl-sm-4 mobile-let-chat">
                                                        <Row>
                                                            <Col md={1} xs={2}>
                                                                <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-sm-4 pt-2" />
                                                            </Col>
                                                            <Col>
                                                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color ppl text-white">
                                                                    Expand your ability to innovate
                                                    </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={1} xs={2}>
                                                                <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-sm-4 pt-2" />
                                                            </Col>
                                                            <Col>
                                                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color pt-sm-0 ppl text-white">
                                                                    Build a dynamic team
                                                    </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={1} xs={2}>
                                                                <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-sm-4 pt-2" />
                                                            </Col>
                                                            <Col>
                                                                <div className="case-study-heading pt-sm-4 pl-sm-2 head-office-color pt-sm-0 ppl text-white">
                                                                    Co-develop custom software
                                                    </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/green-flower-pot.svg`} alt="green-flower-pot" className="mt-sm-5 pt-sm-5 float-right" />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </ScrollAnimation>
                                </Col>
                                <Col className="pl-sm-0 pr-sm-0">
                                    <ScrollAnimation animation='bounceInRight' className="h-100">
                                        <div className="form-box pl-sm-5 pr-sm-5">
                                            <div className="footer-nav-link pl-sm-4 ser-content pt-sm-3 pb-sm-5 ">
                                                Here are the ways you can contact us with any questions you have
                                    </div>
                                            <div className="spectial pl-sm-4 pr-sm-4">
                                                <div className="floating-form">
                                                    <div className="mb-3">
                                                        <div className="floating-label mb-sm-0">
                                                            <input
                                                                className={formValid && name == '' ? "floating-input error-msg-b" : 'floating-input'}
                                                                type="text"
                                                                placeholder=" "
                                                                value={name}
                                                                name="name"
                                                                onChange={(event) => this.handleUserInput(event)} />
                                                            <span className="highlight"></span>
                                                            <label className={formValid && name == '' ? "error-msg" : ''}>Name*</label>
                                                        </div>
                                                        {formValid && name == '' && <span className="error-msg">Please enter name</span>}
                                                    </div>
                                                    <div className="pt-5 mb-3">
                                                        <div className="floating-label mb-sm-0">
                                                            <input
                                                                className={(formValid && phone_number == '' || validPhone) ? "floating-input error-msg-b" : 'floating-input'}
                                                                type="text"
                                                                placeholder=" "
                                                                value={phone_number}
                                                                name="phone_number"
                                                                onChange={(event) => this.handleUserInput(event)} />
                                                            <span className="highlight"></span>
                                                            <label className={(formValid && phone_number == '' || validPhone) ? "error-msg" : ''}>Phone Number*</label>
                                                        </div>
                                                        {(formValid && phone_number == '' || validPhone) && <span className="error-msg">Please enter phone number with country code</span>}
                                                    </div>
                                                    <div className="pt-5 mb-3">
                                                        <div className="floating-label mb-sm-0">
                                                            <input
                                                                className={formValid && email == '' || inValidEmail ? "floating-input error-msg-b" : 'floating-input'}
                                                                type="text"
                                                                placeholder=" "
                                                                value={email}
                                                                name="email"
                                                                onChange={(event) => this.handleUserInput(event)} />
                                                            <span className="highlight"></span>
                                                            <label className={(formValid && email == '' || inValidEmail) ? "error-msg" : ''}>Email*</label>
                                                        </div>
                                                        {formValid && email == '' || inValidEmail && <span className="error-msg">Please enter valid email</span>}
                                                    </div>
                                                    <div className="pt-5 mb-3">
                                                        <div className="floating-label mb-sm-0">
                                                            <textarea
                                                                className={formValid && email == '' ? "floating-input floating-textarea error-msg-b" : 'floating-input floating-textarea'}
                                                                type="text"
                                                                placeholder=" "
                                                                value={message}
                                                                name="message"
                                                                onChange={(event) => this.handleUserInput(event)} />
                                                            <span className="highlight"></span>
                                                            <label className={formValid && message == '' ? "error-msg" : ''}>Message*</label>
                                                        </div>
                                                        {formValid && message == '' && <span className="error-msg">Please enter message</span>}
                                                    </div>
                                                    <div className="mt-4 pt-3 pb-5 width-content" onClick={(event) => this.handleClick(event)}>
                                                        <Cbutton name="Submit" extra={true} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="pl-4">
                                                <HubspotForm
                                                    portalId='6826765'
                                                    formId='e299f2e3-4e04-4c10-a2c9-b4eac140877f'
                                                    onSubmit={() => console.log('Submit!')}
                                                    onReady={(form) => console.log('Form ready!')}
                                                    loading={<div>Loading...</div>}
                                                />
                                            </div> */}
                                        </div>
                                    </ScrollAnimation>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <TalkData title={<span>Got an idea? <br />Talk to us!</span>} subtitle={<span>We’d love to talk about <br className="mobile" />what matters to you.</span>} />
                </Layout>
                <style>
                    {`
                    body{
                        overflow-x: hidden
                    }
                    .edge{
                        color:#fff !important;
                        padding-top:120px;
                        letter-spacing: 5px;
                    }
                    .ppl-09pp{
                        font-size: 24px !important;
                    }
                    .text-white{
                        color:#ffffff !important;
                        line-height: 30px !important;
                    }
                    .form-090f {
                        letter-spacing: 6px;
                        font-size: 50px;
                        color: #fff !important;
                        font-family: "PT Mono", monospace;
                    }
                    `}
                </style>
            </div>
        )
    }
}
